export const imssbienestar = [
  {
    "titulo_item_nombre": "",
    "archivos": [
      {
        "extencion":"archivo-xls",
        "file_item_nombre": "1. Anexo 6 CAF - CAE Partidas 2024",
        "file_item_url": "../../../contenido/transparencia/convenios/Anexo 6 CAF - CAE - Partidas 2024.xlsx"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "2. Acuerdo de coordinación IMSS-Bienestar 2024",
        "file_item_url": "../../../contenido/transparencia/convenios/Acuerdo de Coordinación IMSS-Bienestar 2024.pdf"
      }
    ]
  }
  
  
]